// @ts-nocheck
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import breakpointMediaQueries, { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import getProp from "@insite/mobius/utilities/getProp";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import { transitionHoverStyles } from "@store/Themes/common/mixins/transition";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import { css } from "styled-components";

const _sectionHeaderButtonBaseStyles = () => {
    return css`
        border: none;
        color: ${getColor("primary")};
        line-height: ${({ theme }) => theme.design.typography.lineHeight.base};
        transition: ${transitionHoverStyles("color")};

        ${breakpoint("xs")} {
            padding: ${pxToRem(12)} ${pxToRem(20)};
            margin: ${pxToRem(8)} 0;
            background-color: ${getColor("common.accentLighter")};
        }

        ${breakpoint("md")} {
            position: relative;
            padding: ${pxToRem(2)};
            margin-bottom: 4.5em;
            background-color: ${getColor("common.background")};

            &::after {
                content: "";
                position: absolute;
                right: 0;
                bottom: -2.25em;
                left: 0;
                height: ${pxToRem(1)};
                background-color: ${getColor("common.border")};
            }

            &[aria-expanded="true"] {
                &::after {
                    height: 0;
                }
            }
        }

        &:hover * {
            color: ${getColor("secondary")};
        }

        &[aria-expanded="true"] {
            margin-bottom: 0;
            border-color: transparent;
        }
    `;
};

const _sectionHeaderButtonFocusStyles = () => {
    return css`
        &:focus {
            ${_sectionHeaderButtonBaseStyles()}
            outline-color: ${getProp("theme.focus.color")};
            outline-style: ${getProp("theme.focus.style")};
            outline-width: ${getProp("theme.focus.width")};
            outline-offset: -${getProp("theme.focus.width")};
        }
    `;
};

const accordion: Styleguide["accordion"] = {
    sectionDefaultProps: {
        titleTypographyProps: {
            color: "primary",
            forwardAs: "h3",
            variant: "h3",
            transform: "initial",
            css: css`
                margin-bottom: 0;
                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                font-size: ${({ theme }) => theme.design.typography.size.base};
                                font-weight: ${({ theme }) => theme.design.typography.weight.medium};
                            `,
                        ],
                        mediaOptions.max,
                    )}
            `,
        },
        headerProps: {
            css: css`
                button {
                    ${_sectionHeaderButtonBaseStyles()}
                    ${_sectionHeaderButtonFocusStyles()}
                }

                ${/* sc-selector */ AccordionSectionPanel} + & {
                    margin-top: ${pxToRem(1)};

                    button {
                        ${_sectionHeaderButtonBaseStyles()}
                        ${_sectionHeaderButtonFocusStyles()}
                    }
                }
            `,
        },
        panelProps: {
            css: css`
                border: none;

                ${({ theme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            css`
                                padding: ${pxToRem(12)} ${pxToRem(20)} ${pxToRem(20)};
                            `,
                            null,
                            css`
                                padding: 2.25em ${pxToRem(2)};
                                margin-bottom: 2.25em;
                                border-bottom: ${pxToRem(1)} solid ${getColor("common.border")};
                            `,
                        ],
                        mediaOptions.min,
                    )}
            `,
        },
        toggleIconProps: {
            color: "inherit",
            src: ArrowiOSDownward,
            css: css`
                height: ${({ theme }) => theme.design.typography.lineHeight.base};
                width: ${({ theme }) => theme.design.typography.lineHeight.base};
                position: relative;

                svg {
                    width: inherit;
                    height: inherit;
                    transform: scale(1.231);
                }
            `,
        },
    },
};

export default accordion;
